import { ref } from 'vue'

const type = ref<string>('success')
const message = ref<string | null>(null)

export function useModalMessage() {
  function showSuccess(content: string) {
    type.value = 'success'
    message.value = content
  }
  function showError(content: string) {
    type.value = 'error'
    message.value = content
  }

  return { showSuccess, showError, type, message }
}
